import { extendServiceContainer } from '@iotize/tap';
import { GroupService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    group: GroupService;
  }
}

export const _TAP_SERVICE_EXTENSION_GROUP_ = extendServiceContainer(
  'group',
  GroupService,
);
